<template>
  <div
    class="bg-purple-ap-100 bg-hero min-h-screen flex flex-col items-center justify-center py-6"
  >
    <ChiCard>
      <div class="flex flex-col flex-1 justify-center items-center">
        <h1
          class="text-4xl lg:text-5xl font-regular text-purple-ap-100 font-sil mb-5"
        >
          Register for free to view all our Au Pairs
        </h1>
        <h2></h2>
        <p class="lg:text-xl mb-5 text-purple-ap-100 text-center">
          <strong>No commitment required, outstanding customer service.</strong
          ><br />
          Create a free account to sign and browse our complete list of
          available Au Pairs. Create your own preferred list of Au Pairs and
          request interviews. <br /><strong>All at no cost!</strong>
        </p>
      </div>
      <slot />
    </ChiCard>
  </div>
</template>

<script>
import ChiCard from "@/components/UI/ChiCard.vue";

export default {
  name: "ApplyLayout",
  components: {
    ChiCard,
  },
};
</script>

<style scoped>
@media only screen and (min-width: 1024px) {
  .bg-hero {
    background: url("../../assets/img/cover-apply.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom left;
    background-attachment: fixed;
    overflow: hidden;
  }
}
</style>
